<template>
  <div :id="name" />
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    dataObj: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: "pie"
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.setOption(this.dataObj);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    dataObj(val) {
      this.setOption(val);
    }
  },
  methods: {
    setOption(data) {
      data.forEach( item => {
        item.value = item.count
      })
      var chartDom = document.getElementById(this.name);
      var myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "item"
        },
        title: {
          text:'超期天数占比',
          left: 'center',
          bottom: '0',
          textStyle: {
            fontSize: 14,
            color: '#666',
            fontWeight: 'normal'
          }
        },
        legend: {
          show: true,
          selectedMode: false,
          top: "0%",
          left: "center"
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "66%"],
            center: ['50%', '55%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4,
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "12",
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ]
      };
      option && myChart.setOption(option);
    }
  }
};
</script>
